import { NocoHttpClient } from '@noco/http-client';
import { createConfigurationWithToken } from '../utils';
var Configuration = NocoHttpClient.Configuration;
var SiteApi = /** @class */ (function () {
    function SiteApi(basePath, fetchApi) {
        this.basePath = basePath;
        this.fetchApi = fetchApi;
    }
    SiteApi.initialize = function (basePath, fetchApi) {
        if (!SiteApi.instance) {
            SiteApi.instance = new SiteApi(basePath, fetchApi);
        }
        return SiteApi.instance;
    };
    SiteApi.prototype.ApiFactory = function (idToken) {
        var config = createConfigurationWithToken({
            basePath: this.basePath,
            fetchApi: this.fetchApi,
            idToken: idToken,
            type: 'contact'
        });
        return new NocoHttpClient.ApiContactV1SiteApi(new Configuration(config));
    };
    return SiteApi;
}());
export { SiteApi };
